import PropTypes from "prop-types";

export default function OrderSelect({ value, total, onChange }) {
	const handleChange = (e) => {
		const val = Number(e.target.value);
		if (val > 0) onChange(val);
	};

	return (
		<select 
            value={value} 
            onChange={handleChange} 
            style={{
                height: "30px",
                padding: "2px 6px",
                fontSize: "1.2rem",
                width: "60px",
                borderRadius: "4px"
            }}
        >
			{Array.from({ length: total }, (_, idx) => (
				<option key={idx} value={idx + 1}>
					{idx + 1}
				</option>
			))}
		</select>
	);
}

OrderSelect.propTypes = {
	value: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
